import React from 'react';
import PropTypes from 'prop-types';
import { Translate } from 'react-localize-redux';
import signupCss from '../signup/style.css';
import css from './style.css';

export default function FormDropdown({ labelKey, placeholderKey, value, onChange, error, isLoading, options }) {
    return (
        <div className={css.dropdownField}>
            <div className={css.dropdownLabel}>
                <Translate id={labelKey} />
            </div>
            <Translate>
                {({ translate }) => (
                    <select
                        value={value}
                        onChange={e => onChange(e.target.value)}
                        disabled={isLoading}
                        className={css.dropdownSelect}
                    >
                        <option value="" disabled hidden>{translate(placeholderKey)}</option>
                        {options.map(opt => (
                            <option key={opt.value} value={opt.value}>
                                {opt.labelKey ? translate(opt.labelKey) : opt.label}
                            </option>
                        ))}
                    </select>
                )}
            </Translate>
            {error && (
                <div className={signupCss.errorMessage}>
                    <Translate id={error} />
                </div>
            )}
        </div>
    );
}

FormDropdown.propTypes = {
    labelKey: PropTypes.string.isRequired,
    placeholderKey: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    error: PropTypes.string,
    isLoading: PropTypes.bool,
    options: PropTypes.arrayOf(PropTypes.shape({
        value: PropTypes.string.isRequired,
        label: PropTypes.string,
        labelKey: PropTypes.string,
    })).isRequired,
};
